<p-toast></p-toast>

<div class="card">
  <h2>Actualizacion de Usuario</h2>

  <form [formGroup]="formUsuario" (ngSubmit)="onSubmit()">
    <div class="p-fluid grid">
      <!--
      <div class="col-12 md:col-6">
        <label>Usuario</label>
        <input pInputText type="text"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          formControlName="usuario" [ngClass]="{'ng-invalid ng-dirty': f['usuario'].touched && f['usuario'].errors}" />
        <small class="p-error" *ngIf="f['usuario'].touched && f['usuario'].errors?.['required']">
          El usuario es requerido
        </small>
        <small class="p-error" *ngIf="f['usuario'].touched && f['usuario'].errors?.['email']">
          El usuario es invalido debe de ser formato de correo electronico
        </small>
      </div>

      <div class="col-12 md:col-6">
        <label>Contrasena</label>
        <input pInputText type="password"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          formControlName="password"
          [ngClass]="{'ng-invalid ng-dirty': f['password'].touched && f['password'].errors}" />
        <small class="p-error" *ngIf="f['password'].touched && f['password'].errors?.['required']">
          El password es requerido
        </small>
      </div>
-->
      <div class="col-12 md:col-6">
        <label>Alias</label>
        <input pInputText type="text"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          formControlName="alias" [ngClass]="{'ng-invalid ng-dirty': f['alias'].touched && f['alias'].errors}" />
        <small class="p-error" *ngIf="f['alias'].touched && f['alias'].errors?.['required']">
          El alias es requerido
        </small>
      </div>

      <div class="col-12 md:col-6">
        <label>Nombre</label>
        <input pInputText type="text"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          formControlName="nombre" [ngClass]="{'ng-invalid ng-dirty': f['nombre'].touched && f['nombre'].errors}" />
        <small class="p-error" *ngIf="f['nombre'].touched && f['nombre'].errors?.['required']">
          El nombre es requerido
        </small>
      </div>

      <div class="col-12 md:col-6">
        <label>Primer Apellido</label>
        <input pInputText type="text"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          formControlName="primerApellido"
          [ngClass]="{'ng-invalid ng-dirty': f['primerApellido'].touched && f['primerApellido'].errors}" />
        <small class="p-error" *ngIf="f['primerApellido'].touched && f['primerApellido'].errors?.['required']">
          El Apellido Paterno es requerido
        </small>
      </div>

      <div class="col-12 md:col-6">
        <label>Segundo Apellido</label>
        <input pInputText type="text"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          formControlName="segundoApellido" />
      </div>

      <div class="col-12 md:col-6">
        <label>Telefono Movil</label>
        <input pInputText type="text" maxlength="10"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          formControlName="telefonoMovil" />
      </div>

      <div class="col-12 md:col-6">
        <label>Rol</label>
        <p-dropdown [options]="roles" optionLabel="descripcion" optionValue="id" formControlName="fk_rol"
          [ngClass]="{'ng-invalid ng-dirty': f['fk_rol'].touched && f['fk_rol'].errors}"></p-dropdown>
        <small class="p-error" *ngIf="f['fk_rol'].touched && f['fk_rol'].errors?.['required']">
          El Rol es requerido
        </small>
      </div>

      <div class="col-12 md:col-6">
        <label>Nivel</label>
        <p-dropdown [options]="niveles" optionLabel="descripcion" optionValue="id" formControlName="fk_nivel"
          [ngClass]="{'ng-invalid ng-dirty': f['fk_nivel'].touched && f['fk_nivel'].errors}"></p-dropdown>
        <small class="p-error" *ngIf="f['fk_nivel'].touched && f['fk_nivel'].errors?.['required']">
          El Nivel es requerido
        </small>
      </div>
    </div>

    <div *ngIf="formUsuario.get('fk_rol')?.value === ROLE.MEDICO" formGroupName="medico"
      class="mt-4 p-fluid grid border-top-1 pt-3">
      <div class="field col-12 md:col-6">
        <label for="estado">Entidad Federativa *:</label>
        <p-dropdown formControlName="fk_estado" inputId="estado" [options]="estados" optionLabel="label"
          optionValue="value" styleClass="w-full" placeholder="Seleccione un Estado" [emptyMessage]="'Sin resultados'"
          [emptyFilterMessage]="'Sin resultados'" />
      </div>

      <div class="field col-12 md:col-6">
        <label for="institucion">Institucion *:</label>
        <p-dropdown formControlName="fk_institucion" inputId="institucion" [options]="instituciones" optionLabel="label"
          optionValue="value" styleClass="w-full" placeholder="Seleccione una Institucion"
          [emptyMessage]="'Sin resultados'" [emptyFilterMessage]="'Sin resultados'" />
      </div>

      <div class="field col-12 md:col-12">
        <label for="hospital">Hospital *: </label>
        <p-dropdown inputId="hospital" [options]="hospitales" formControlName="fk_hospital" optionLabel="nomHospital"
          optionValue="id" [showClear]="true" placeholder="Seleccione un hospital"
          [ngClass]="{'ng-invalid ng-dirty': formUsuario.get('medico.fk_hospital')?.touched && formUsuario.get('medico.fk_hospital')?.errors}"
          [emptyMessage]="'Sin resultados'">
        </p-dropdown>
        <small class="p-error"
          *ngIf="formUsuario.get('medico.fk_hospital')?.touched && formUsuario.get('medico.fk_hospital')?.errors?.['required']">
          El hospital es requerido
        </small>
      </div>

      <div class="field col-12 md:col-6">
        <label for="especialidad">Especialidad</label>
        <p-dropdown inputId="especialidad" [options]="especialidades" formControlName="fk_especialidad"
          optionLabel="nomEspecialidad" optionValue="id" [showClear]="true" placeholder="Seleccione una especialidad"
          [ngClass]="{'ng-invalid ng-dirty': formUsuario.get('medico.fk_especialidad')?.touched && formUsuario.get('medico.fk_especialidad')?.errors}"
          [emptyMessage]="'Sin resultados'">
        </p-dropdown>
      </div>

      <div class="field col-12 md:col-6">
        <label for="puesto">Puesto</label>
        <p-dropdown inputId="puesto" [options]="puestos" formControlName="fk_puesto" optionLabel="descripcion"
          optionValue="id" [showClear]="true" placeholder="Seleccione un puesto"
          [ngClass]="{'ng-invalid ng-dirty': formUsuario.get('medico.fk_puesto')?.touched && formUsuario.get('medico.fk_puesto')?.errors}"
          [emptyMessage]="'Sin resultados'">
        </p-dropdown>
      </div>

      <div class="field col-12 md:col-4">
        <label for="noconsultorio">No. Consultorio</label>
        <input id="noconsultorio" type="text" pInputText [maxlength]="90" formControlName="noConsultorio"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary">
      </div>

      <div class="field col-12 md:col-4">
        <label for="telconsultorio">Telefono Consultorio</label>
        <input id="telconsultorio" type="text" pInputText formControlName="telefonoConsultorio" [maxlength]="10"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary">
      </div>

      <div class="field col-12 md:col-4">
        <label for="telmovil">Telefono Movil</label>
        <input id="telmovil" type="text" pInputText [maxlength]="10" formControlName="telefonoMovil"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary">
      </div>

      <div class="field col-12 md:col-6">
        <label for="hospitalconsultorioprivado">Consultorio Privado</label>
        <input id="hospitalconsultorioprivado" type="text" pInputText [maxlength]="90"
          formControlName="hospitalConsultorioPrivado"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
      </div>

      <div class="field col-12 md:col-6"></div>

      <div class="field col-12 md:col-6">
        <label for="direccionconsultorioprivado">Direccion Consultorio Privado</label>
        <input id="direccionconsultorioprivado" type="text" pInputText formControlName="noConsultorioDireccionPrivado"
          [maxlength]="100"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
      </div>

      <div class="field col-12 md:col-6">
        <label for="telconsultorioprivado">Telefono Consultorio Privado</label>
        <input id="telconsultorioprivado" type="text" pInputText formControlName="telefonoConsultorioPrivado"
          [maxlength]="10"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary">
      </div>
    </div>

    <div *ngIf="formUsuario.get('fk_rol')?.value === ROLE.ENFERMERA" formGroupName="enfermera"
      class="mt-4 p-fluid grid border-top-1 pt-3">
      <div class="col-12 md:col-6">
        <label for="puntos">Puntos</label>
        <p-dropdown inputId="puntos" [options]="puntos" formControlName="fk_puntos" optionLabel="label"
          optionValue="value" [showClear]="true" placeholder="Seleccione un puntos"
          [ngClass]="{'ng-invalid ng-dirty': formUsuario.get('enfermera.fk_puntos')?.touched && formUsuario.get('enfermera.fk_puntos')?.errors}"
          [emptyMessage]="'Sin resultados'">
        </p-dropdown>
      </div>
    </div>

    <div *ngIf="formUsuario.get('fk_rol')?.value === ROLE.SUPERVISOR" formGroupName="supervisor"
      class="mt-4 p-fluid grid border-top-1 pt-3">
      <div class="col-12 md:col-6">
        <label>Telefono</label>
        <input pInputText type="text"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          formControlName="telefonoMovil" />
      </div>
    </div>

    <div class="field col-12 md:col-4">
      <p-button type="button" label="Cancelar" (click)="cancelar()" styleClass="p-button-sm mr-3"></p-button>
      <p-button type="submit" label="Actualizar" icon="pi pi-save" [disabled]="formUsuario.invalid">
      </p-button>
    </div>
  </form>
</div>